__turbopack_context__.v({
  "actions": "market-tile-module__mnR-ca__actions",
  "anchor": "market-tile-module__mnR-ca__anchor",
  "anchors": "market-tile-module__mnR-ca__anchors",
  "body": "market-tile-module__mnR-ca__body",
  "btc": "market-tile-module__mnR-ca__btc",
  "figure": "market-tile-module__mnR-ca__figure",
  "finePrint": "market-tile-module__mnR-ca__finePrint",
  "glyph": "market-tile-module__mnR-ca__glyph",
  "kicker": "market-tile-module__mnR-ca__kicker",
  "label": "market-tile-module__mnR-ca__label",
  "labelLong": "market-tile-module__mnR-ca__labelLong",
  "labelShort": "market-tile-module__mnR-ca__labelShort",
  "link": "market-tile-module__mnR-ca__link",
  "meta": "market-tile-module__mnR-ca__meta",
  "nowrap": "market-tile-module__mnR-ca__nowrap",
  "primary": "market-tile-module__mnR-ca__primary",
  "retry": "market-tile-module__mnR-ca__retry",
  "sellAction": "market-tile-module__mnR-ca__sellAction",
  "sellActions": "market-tile-module__mnR-ca__sellActions",
  "sellBody": "market-tile-module__mnR-ca__sellBody",
  "sellCard": "market-tile-module__mnR-ca__sellCard",
  "sellContent": "market-tile-module__mnR-ca__sellContent",
  "sellGlyph": "market-tile-module__mnR-ca__sellGlyph",
  "sellLabel": "market-tile-module__mnR-ca__sellLabel",
  "sellNow": "market-tile-module__mnR-ca__sellNow",
  "sellOffer": "market-tile-module__mnR-ca__sellOffer",
  "sellOutline": "market-tile-module__mnR-ca__sellOutline",
  "sellPrice": "market-tile-module__mnR-ca__sellPrice",
  "sellTitle": "market-tile-module__mnR-ca__sellTitle",
  "sellUsd": "market-tile-module__mnR-ca__sellUsd",
  "sellViewAll": "market-tile-module__mnR-ca__sellViewAll",
  "skeletonButton": "market-tile-module__mnR-ca__skeletonButton",
  "skeletonFigure": "market-tile-module__mnR-ca__skeletonFigure",
  "skeletonShort": "market-tile-module__mnR-ca__skeletonShort",
  "tile": "market-tile-module__mnR-ca__tile",
  "tile-ring": "market-tile-module__mnR-ca__tile-ring",
});
